var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.94586 12.9491C6.1595 12.9491 7.14334 12.0802 7.14334 10.7516V0.895508H9.77874C9.63092 2.69299 11.4178 4.42931 13.3884 4.3896V6.86775C11.7031 6.86775 10.27 6.15515 9.77124 5.75968V10.7516C9.77124 12.9491 8.04252 15.441 4.94586 15.441C1.8492 15.441 0.158203 12.9491 0.158203 10.7516C0.158203 7.65006 3.44042 5.85129 5.6143 6.29094V8.81509C5.50494 8.7764 5.22292 8.7192 4.9827 8.7192C3.75898 8.67409 2.74838 9.6666 2.74838 10.7516C2.74838 11.9652 3.73223 12.9491 4.94586 12.9491Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.a51e4cd85f2a640ffb6ca579067a035e.svg";
export { ForwardRef as ReactComponent };